export const featuredProductsSliderSettings = {
    accessibility: false,
    slidesToShow: 6,
    slidesToScroll: 6,
    dots: true,
    variableWidth: true,
    adaptiveHeight: false,
    infinite: false,
    responsive: [
        {
            breakpoint: 576,
            settings: {
                slidesToShow: 2,
                slidesToScroll: 1,
                dots: true,
                arrows: true,
                variableWidth: false
            }
        },
        {
            breakpoint: 768,
            settings: {
                slidesToShow: 4,
                slidesToScroll: 4,
                dots: true,
                arrows: true,
                variableWidth: false
            }
        },
        {
            breakpoint: 992,
            settings: {
                slidesToShow: 5,
                slidesToScroll: 5,
                dots: true,
                arrows: true,
                variableWidth: true
            }
        }
    ]
}